import { ww } from 'bobjoll/ts/library/dom';

export const callHotjarTrigger = (hjTrigger: string) => {
    if (ww.hj && typeof ww.hj === 'function') {
        ww.hj('trigger', hjTrigger);
    }
};
